import { ModalComponentProps } from "@quillsql/react"
import { useCallback, useRef } from "react"

import { Dialog } from "@molecules"
import DialogHeader from "@molecules/Dialog/DialogHeader/DialogHeader"

import styles from "./QuillDialog.module.scss"

export default function QuillDialog(props: ModalComponentProps) {
    const { title, isOpen, setIsOpen, children } = props

    const setIsOpenRef = useRef(setIsOpen)
    setIsOpenRef.current = setIsOpen

    const stableSetIsOpen = useCallback((open: boolean) => {
        setIsOpenRef.current?.(open)
    }, [])

    const nonFocusedTitles = new Set<string>(["select columns", "add filter", "add pivot", "add sort", "add limit"])
    const isNonFocused = nonFocusedTitles.has(title?.toLowerCase() || "")

    return (
        <Dialog.Root
            mode="dialog"
            variant={isNonFocused ? "default" : "focused"}
            isOpen={isOpen}
            onOpenChange={stableSetIsOpen}
        >
            <Dialog.Content className={styles.base}>
                <DialogHeader.Root>
                    <DialogHeader.Title title={title ?? ""} />
                    <DialogHeader.CloseButton />
                </DialogHeader.Root>
                <Dialog.Body>
                    <div className={styles.body}>{children}</div>
                </Dialog.Body>
            </Dialog.Content>
        </Dialog.Root>
    )
}
